import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { BusinessPriceTier } from '@barboxx/models';

interface Props {
    businessPriceTier: BusinessPriceTier.DetailsResponse;
}

export const BusinessPriceTierDeleteCard = ({ businessPriceTier }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteBusinessPriceTier = useMutation({
        mutationKey: ['deleteBusinessPriceTier', businessPriceTier.id],
        mutationFn: () =>
            Api.BusinessSpecific.PriceTier.deletePriceTier(businessPriceTier),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this Price Tier!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Price Tier',
            }
        );

        if (!deleteConfirmed) {
            return;
        }
        mutateDeleteBusinessPriceTier
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted business price tier!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting business price tier!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete BusinessPriceTier" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this business price
                        tier?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
